module.exports = __webpack_public_path__ + "static/media/CubbyLogo.bc374859.png";